import { User } from "src/app/components/catalogs/user-catalog/services/user";
import { LogSignature, LogUpdate } from "./form-history.service";
import { WfSignatureResource } from "src/app/components/workflow/workflow";

export class FormHistoryServicesHelper {

	static getLogHeadText(amendmentId: number, amendmentsSet: Set<number>): string {
		const amendmentNumber = Array.from(amendmentsSet).indexOf(amendmentId ?? 0) + 1;
		const res = (amendmentNumber ? ('<span class="yellow">Amendment ' + amendmentNumber) : '<span class="red">Amendment Cancelled') + '</span>';
		return res;
	}

	static createBody(jsonBody: string, users: User[]) {
		const body = JSON.parse(jsonBody);

		if (body) {
			// User names
			body.createdByName = users.find(u => u.id === body.createdBy)?.name;
			body.requesterName = users.find(u => u.id === body?.requesterId)?.name;
		}
		return body;
	}

	static getAmendmentList(signatures: LogSignature[]): number[] {
		let prevAmendmentID = -1;
		let res: number[] = [];
		signatures.filter(s => !!s.amendmentId).map(t => {
			if (t.amendmentId !== prevAmendmentID) {
				prevAmendmentID = t.amendmentId ?? 0;
				res.push(prevAmendmentID);
			}
		});

		res = [...new Set(res)].sort((a, b) => a - b);
		return res;
	}

}